import * as React from 'react';
import { 
    useGetOne, 
    useMutation, 
    SimpleForm, 
    Toolbar,
    SaveButton, 
    SelectInput,
} from 'react-admin';
import { Card, CardContent, Typography, Box, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { notifySuccess } from '../util';
import { translate } from '../i18n/customI18nProvider';

const useStyles = makeStyles({
    card: {
        marginBottom: '24px',
        marginTop: '16px',
        backgroundColor: '#f5f5f5'
    },
    toolbar: {
        backgroundColor: 'transparent',
        minHeight: 'auto',
        padding: 0
    },
    input: {
        minWidth: 250
    }
});

const CustomToolbar = props => {
    const classes = useStyles();
    return (
        <Toolbar {...props} className={classes.toolbar}>
            <SaveButton />
        </Toolbar>
    );
};

export const MinVersionForm = () => {
    const classes = useStyles();

    const { data, loading } = useGetOne('v1/settings', 'min_version');

    const [versions, setVersions] = React.useState([]);

    React.useEffect(() => {
        fetchVersions();
    }, []);

    const fetchVersions = async () => {
        try {
            const response = await fetch('/api/latest_app');
            const result = await response.json();
            result.sort((a, b) => b.version.localeCompare(a.version, undefined, { numeric: true }));
            setVersions(result);
        } catch (error) {
            console.error('Error while fetching versions:', error);
        }
    };
    
    const [mutate] = useMutation();

    const handleSubmit = (formData) => {
        mutate(
            {
                type: 'update',
                resource: 'v1/settings',
                payload: { id: 'min_version', data: formData, previousData: data }
            },
            {
                onSuccess: () => notifySuccess('custom.minimum_version_updated'),
                onFailure: () => notifyError(translate('custom.an_error_occured')),
            }
        );
    };

    if (loading) return null;

    return (
        <Card className={classes.card}>
            <CardContent>
                <Typography variant="h6" gutterBottom color="primary">
                    {translate('custom.minimum_version_title')}
                </Typography>
                
                <SimpleForm 
                    record={data} 
                    save={handleSubmit} 
                    toolbar={<CustomToolbar />}
                >
                    <Grid style={{ width: '100%' }} container spacing={2}>
                        <Grid item xs={12} sm={6} md={4}>                            
                            <SelectInput
                                label={translate('custom.minimum_version_label')}
                                source="version"
                                choices={versions}
                                optionText="version"
                                optionValue="version"
                                variant='outlined'
                                fullWidth
                            />
                        </Grid>
                    </Grid>
                </SimpleForm>
            </CardContent>
        </Card>
    );
};